module.exports = __webpack_public_path__ + "static/media/Artboard 1 copy 72300.175c5c65.png";